export default __webpack_public_path__ + "static/media/wallet.cb78b87c.svg";